export default [
  { name: 'MEMBER_FOR_OWN_ACCOUNT', value: 1 },
  { name: 'PROPRIETARY_FIRM_TRADING', value: 2 },
  { name: 'MEMBER_FOR_ANOTHER_MEMBER', value: 3 },
  { name: 'ALL_OTHER', value: 4 },
];
